import { TranslateText } from '@/helpers/utils/siteUtils';
import { DEFAULT_SITE_LANG } from '../../../../../constants/constant';
import { TableColumnConfig } from '../../ui/customTable/Table';
import { PageTexts } from '../i18n';

const Texts = TranslateText(PageTexts, DEFAULT_SITE_LANG);

export const CUSTOMER_DETAILS_HEADER_KEYS = {
  ACCOUNT_NUMBER: 'Account Number',
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  COMPANY_NAME: 'Company Name',
  PHONE_NUMBER: 'Primary Phone',
  EMAIL_ADDRESS: 'Email Address',
  DATE_OF_BIRTH: 'Date of Birth',
  SOCIAL_SECURITY_NUMBER: 'Social Security #',
  ADDRESS_LINE_1: 'Address 1',
  ADDRESS_LINE_2: 'Address 2',
  CITY: 'City',
  STATE: 'State',
  ZIP_CODE: 'Zip Code',
  WEB_ACCOUNT_NUMBER: 'Web Account Number',
  DIVISION_ID: 'Division ID',
  MAIL_RETURN_UNDELIVERABLE: 'Mail Return Undeliverable',
  PHONE: 'Phone Number',
  DIVISIONS: 'Division(s)',
  STREET_NAME: 'Address Line 1',
  ADDITIONAL_ADDRESS: 'Address Line 2',
};

export const CUSTOMER_DETAILS_RECORD_KEYS = {
  ACCOUNT_NUMBER: 'accountNumber',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  COMPANY_NAME: 'companyName',
  PHONE_NUMBER: 'phoneNumber',
  EMAIL_ADDRESS: 'emailAddress',
  DATE_OF_BIRTH: 'dateOfBirth',
  SOCIAL_SECURITY_NUMBER: 'socailSecurityNumber',
  ADDRESS_LINE_1: 'addressLine1',
  ADDRESS_LINE_2: 'addressLine2',
  CITY: 'city',
  STATE: 'state',
  ZIP_CODE: 'zipCode',
  WEB_ACCOUNT_NUMBER: 'webAccountNumber',
  DIVISION_ID: 'divisionId',
  MAIL_RETURN_UNDELIVERABLE: 'mailReturnUndeliverable',
  ACTION: 'action',
};

export const CUSTOMER_PREFRENCE_HEADER_KEYS = {
  description: 'description',
  displayName: 'displayName',
  updatedOn: 'updatedOn',
  updatedBy: 'updatedBy',
  agent: 'agent',
  value: 'value',
  timeStamp: 'timestamp',
};

export const CUSTOMER_PREFRENCE_RECORD_KEYS = {
  description: 'Description',
  agent: 'Agent',
  value: 'Value',
  timeStamp: 'Date-Time',
};

export const FORM_FIELD_SPECS = {
  phoneNumber: {
    id: 'phoneNumber',
  },
  phone: {
    id: 'phone',
  },
  emailAddress: {
    id: 'emailAddress',
    maxLength: 100,
  },
  zip: {
    id: 'zip',
  },
  lastName: {
    id: 'lastName',
  },
  firstName: {
    id: 'firstName',
  },
  companyName: {
    id: 'companyName',
  },
  addressLine1: {
    id: 'addressLine1',
  },
  line1: {
    id: 'line1',
  },
  line2: {
    id: 'line2',
  },
  addressLine2: {
    id: 'addressLine2',
  },
  city: {
    id: 'city',
  },
  state: {
    id: 'state',
  },
  dateOfBirth: {
    id: 'dob',
  },
  ssn: {
    id: 'ssn',
  },
  catalogId: { id: 'mailingRecordId', maxLength: 10 },
};

export const customerDetailsSchemaMessages = {
  firstNameRequired: 'Please enter your first name',
  firstNameInvalid: 'Please enter a valid first name',
  lastNameInvalid: 'Please enter a valid last name',
  lastNameRequired: 'Please enter your last name',
  emailInvalid: 'Please enter a valid email address',
  addressInvalid: 'Please enter a valid Address',
  stateRequired: 'Select State',
  postalCodeInvalid: 'Please enter a valid Zip Code',
  phoneInvalid: 'Phone number must have at least 10 digits',
  phoneInvalidLength: 'Phone number must have 10 digits',
  ssnRequired: 'Please enter your SSN Number',
  ssnInvalid: 'Please enter a valid SSN Number',
  dobInvalid: 'Please use mm/dd/yyyy format.',
  companyNameInvalid: 'Please enter a valid Company Name',
  cityInvalid: 'Please enter a valid city name',
  phoneNumberInavlid: 'Please enter a valid phone number',
  addressLine1Required: 'Please enter your address',
  cityRequired: 'Please enter your city',
  zipRequired: 'Please enter your zip code',
  additionalAddressInfo: 'Confirm Your House/ Building Number',
  invalidPhoneNumberMessage: 'Your phone number cannot be all zeroes. Please enter a valid 10-digit phone number.',
};

export const NOTES_HEADER_KEYS = {
  AGENT: 'Agent',
  DATE_TIME: 'Date-Time',
  ORDER_DATE_TIME: 'Date/Time',
  NOTES: 'Notes',
};

export const NOTES_RECORD_KEYS = {
  AGENT: 'agent',
  DATE_TIME: 'dateTime',
  NOTES: 'notes',
  VALUE: 'value',
  TIMESTAMP: 'timeStamp',
  AGENT_NAME: 'agentName',
};

export const ORDER_HEADER_KEYS = {
  ORDER_ID: 'Order ID',
  ORDER_DATE: 'Order Date',
  STATUS: 'Status',
  TOTAL_ITEMS: '# of Items',
  PAYMENT_METHOD: 'Payment Method',
  LAST_MODIFIED: 'Last Modified On',
  ORIGIN: 'Origin',
  TOTAL: 'Total',
};

export const ORDER_RECORD_KEYS = {
  ORDER_ID: 'orderId',
  ORDER_DATE: 'submittedOn',
  STATUS: 'statusDescription',
  TOTAL_ITEMS: 'totalItems',
  PAYMENT_METHOD: 'paymentMethod',
  LAST_MODIFIED: 'lastModifiedOn',
  ORIGIN: 'origin',
  TOTAL: 'totalAmount',
};

export const CREDIT_SUMMARY_LABELS = {
  CREDIT_LIMIT: 'Credit Limit',
  TOTAL_BALANCE: 'Total Balance',
  AVAILABLE_CREDIT: 'Available Credit',
  MONTHLY_PAYMENT: 'Monthly Payment',
  ACCOUNT_STATUS: 'Account Status',
  PAYMENT_DUE_DATE: 'Payment Due Date',
  MIN_PAYMENT_DUE: 'Min. Payment Due',
  LAST_STATEMENT_DATE: 'Last Statement Date',
  NEXT_STATEMENT_DATE: 'Next Statement Date',
  AMOUNT_PAST_DUE: 'Amount Past Due',
  INTEREST_RATE: 'Interest Rate',
  INTERNET_CREDIT_OFFER: 'Internet Credit Offer',
  PREQUAL_EXP_DATE: 'PreQual Exp Date',
  LAST_PREQUAL_STATUS: 'Last PreQual Status',
};

export const PAYLOAD_QUERY = {
  X_INITATED_ON: 'X_INITATED_ON',
  CUSTOMER_ID: 'customerId',
  DIVISION_CODE: 'divisionCode',
  OMS_CUSTOMER_ID: 'omsCustomerId',
  X_DivisionCode: 'X_DivisionCode',
  durationInMonths: 'durationInMonths',
  ORDER_ID: 'orderId',
  CREDIT_ID: 'creditAccountId',
};

export const NOTE_TYPES = {
  CUSTOM_NOTE: 'Custom Note',
  PAYMENT_ON_ACCOUNT: 'Payment on Account',
  PAYMENT_ON_ACCOUNT_TRANSFER: 'Payment on Account - Transfer',
  DUE_DATE_CHANGE_REQUEST: 'Due Date Change Request',
  CREDIT_QUESTION_TRANSFER: 'Credit Question - Transfer',
  CLOSE_ACCOUNT_TRANSFER: 'Close Account - Transfer',
  BILLING_ADDRESS_UPDATE_POLICY: 'Billing Address Update - Policy',
  CONTACT_INFO_UPDATE: 'Contact Info Update',
  STOP_EMAIL_CATALOG: 'Stop Email/Catalog',
  START_EMAIL_CATALOG: 'Start Email/Catalog',
  REPLACEMENT_CATALOG_REQUEST: 'Replacement Catalog Request',
};

export const CREDIT_HISTORY_KEYS = {
  DATE: 'createdOn',
  STATUS: 'transactionStatus',
  DESCRIPTION: 'description',
  PURCHASE: 'purchaseChargeAmt',
  PAYMENT: 'paymentCreditAmt',
  NEW_BALANCE: 'updatedRunningBalanceAmt',
  AMOUNT: 'amount',
};
export const ORDER_TOTAL_DETAILS_KEYS = {
  HEADER: 'displayHeader',
  INVOICED: 'invoice',
  BACKORDER: 'backorder',
  READY_TO_SHIP: 'ready_to_ship',
  EST_ORDER_TOTAL: 'est_order_total',
};
export const ORDER_TOTAL_DETAILS_HEADER = {
  HEADER: '',
  INVOICED: 'Invoiced',
  BACKORDER: 'Backordered',
  READY_TO_SHIP: 'Ready to Ship',
  EST_ORDER_TOTAL: 'Est. Order Total',
};

export const CREDIT_HISTORY_HEADERS = {
  DATE: 'Date',
  STATUS: 'Status',
  DESCRIPTION: 'Description',
  PURCHASE: 'Purchase/Charge',
  PAYMENT: 'Payment/Credit',
  NEW_BALANCE: 'New Balance',
};

export const SHIP_ADDRESS_KEYS = {
  FULL_NAME: 'fullName',
  LINE1: 'line1',
};

export const SHIP_ADDRESS_HEADERS = {
  NAME: 'Name',
  ADDRESS: 'Address',
  DEFAULT_SHIPPING: 'Default Shipping',
  ACTIONS: 'Actions',
};

export const REFUND_CHECK_HISTORY = 'refundCheck';
export const CATALOG_MAIL_HISTORY = 'catalogHistory';

export const REFUND_CHECK_HISTORY_HEADER = {
  DATE_SENT: 'Date Sent',
  CHECK_NUMBER: 'Check Number',
  CHECK_AMOUNT: 'Check Amount',
  STATUS: 'Status',
  CLOSED_DATE: 'Closed Date',
};

export const REFUND_CHECK_HISTORY_KEYS = {
  DATE_SENT: 'createdOn',
  CHECK_NUMBER: 'checkNumber',
  CHECK_AMOUNT: 'amount',
  STATUS: 'statusDescription',
  CLOSED_DATE: 'clearedBankOn',
};

export const CATALOG_DETAILS_HEADERS = {
  LAST_REQUESTED_DATE: 'Last Requested Date',
  CATALOG_ID: 'Catalog ID',
  MAIL_DATE: 'Mail Date',
  PROMO_CODE: 'Promo Code',
  CATALOG_EXPIRATION_DATE: 'Catalog Expiration Date',
};
export const CATALOG_DETAILS_KEYS = {
  LAST_REQUESTED_DATE: 'lastCatalogRequestedOn',
  CATALOG_ID: 'mailingRecordId',
  MAIL_DATE: 'mailedOn',
  PROMO_CODE: 'orderPromotionCode',
  CATALOG_EXPIRATION_DATE: 'offerExpiresOn',
};

export const PAYMENT_METHODS_VALUE = {
  CREDIT_CARD: 'creditCard',
  DEBIT_CARD: 'debitCard',
};

export const PAYMENT_METHODS_LABEL = {
  CREDIT_CARD: 'Credit Card',
  DEBIT_CARD: 'Debit Card',
};

export const TOAST_DURATION = 2000;
export const SUCCESS_CSS = 'bg-[#E7F6ED] border-[2px] border-forestGreen px-4 py-4 text-black font-semibold';
export const ERROR_CSS = 'bg-[#FFEBEB] border-[2px] border-scarletRed px-4 py-4 text-black font-semibold';

export const ORDER_HISTORY_ITEMS_PER_PAGE = 5;
export const PAYMENT_GUARDIAN_HEADERS = {
  PAYMENT_GUARDIAN_ELIGIBLE: 'Payment Guardian Eligible',
  STATUS: 'Status',
  ENROLLMENT_DATE: 'Enrollment Date',
  CANCELLATION_DATE: 'Cancellation Date',
};

export const PAYMENT_GUARDIAN_KEYS = {
  PAYMENT_GUARDIAN_ELIGIBLE: 'isEligible',
  STATUS: 'enrollmentStatus',
  ENROLLMENT_DATE: 'enrolledOn',
  CANCELLATION_DATE: 'cancelledOn',
};

export const TYPE_CATALOG = 'Catalog';

export const OrderNotesTableHeaders: TableColumnConfig<any>[] = [
  { key: NOTES_RECORD_KEYS.AGENT, header: NOTES_HEADER_KEYS.AGENT },
  { key: NOTES_RECORD_KEYS.DATE_TIME, header: NOTES_HEADER_KEYS.ORDER_DATE_TIME },
  { key: NOTES_RECORD_KEYS.NOTES, header: NOTES_HEADER_KEYS.NOTES },
];

export const cardRegex = {
  Visa: /^4\d{12}(?:\d{3})?$/,
  Mastercard: /^5[1-5]\d{14}|^(222[1-9]|22[3-9]\d|2[3-6]\d{2}|27[0-1]\d|2720)\d{12}$/,
  Discover: /^6(?:011|5\d{2})\d{12}$/,
  AmericanExpress: /^3[47]\d{13}$/,
};

export const PAYMENT_FORM_SPECS = {
  cardNumber: {
    id: 'cardNumber',
    label: 'cardNumber',
    placeHolder: '*Card Number',
  },
  expDate: {
    id: 'expDate',
    label: 'expDate',
    placeHolder: '*Exp. Date (MM/YY)',
  },
  cvv: {
    id: 'cvv',
    label: 'securityCode',
    placeHolder: '*Security Code',
  },
};

export const CARD_NAMES = {
  AMERICAN_EXPRESS: 'americanexpress',
  VISA: 'visa',
  MASTERCARD: 'mastercard',
  DISCOVER: 'discover',
};

export const TRANSACTION_TYPE = 'credit account payment';
export const DOWN_PAYMENT_TRANSACTION_TYPE = 'down payment with order';

export const PAYMENT_TYPE = {
  otherAmount: 'otherAmount',
  minimumDue: 'minimumDue',
  totalAmount: 'totalAmount',
};

export const PAYMENT_METHODS = {
  minimumDue: 'minimumDue',
  totalAmount: 'totalAmount',
  otherAmount: 'otherAmount',
};

export const dobRegex = /^(19|20)\d\d-(0[1-9]|1[012])-(0[1-9]|[12]\d|3[01])$/;
export const mobileNumberPattern = /^\d{3}-\d{3}-\d{4}$/;

export const numericRegex = /^(?!0000$)\d+$/;

export const customerNoteOptions = [
  NOTE_TYPES.CUSTOM_NOTE,
  NOTE_TYPES.PAYMENT_ON_ACCOUNT,
  NOTE_TYPES.PAYMENT_ON_ACCOUNT_TRANSFER,
  NOTE_TYPES.DUE_DATE_CHANGE_REQUEST,
  NOTE_TYPES.CREDIT_QUESTION_TRANSFER,
  NOTE_TYPES.CLOSE_ACCOUNT_TRANSFER,
  NOTE_TYPES.BILLING_ADDRESS_UPDATE_POLICY,
  NOTE_TYPES.CONTACT_INFO_UPDATE,
  NOTE_TYPES.STOP_EMAIL_CATALOG,
  NOTE_TYPES.START_EMAIL_CATALOG,
  NOTE_TYPES.REPLACEMENT_CATALOG_REQUEST,
];

export const DEFAULT_COUNTRY = 'US';

export const RESPONSE_SUCCESS_MESSAGE = 'OK';
export const RESPONSE_POTENTIAL_MATCH_FOUND = 'MATCH FOUND';
export const RESPONSE_EXISTING_CUSTOMER_FOUND = 'Existing Customer found';

export const CUSTOMER_NOTES_ITEMS_PER_PAGE = 5;
export const CREDIT_HISTORY_ITEMS_PER_PAGE = 10;
export const REFUND_HISTORY_PER_PAGE = 5;
export const CREDIT_NOTES_ITEMS_PER_PAGE = 5;
export const SHIPPING_ADDRESS_ITEM_PER_PAGE = 5;
export const CATALOG_RECORDS_PER_PAGE = 5;

export const ORDER_HISTORY_DURATION = {
  LAST_12_MONTHS: '12',
  LAST_2_YEARS: '24',
  ALL_ORDERS: '255',
};

export const ORDER_SECTION_TABS = {
  ORDER_HISTORY: 'Order_History',
  HOLD_ORDER: 'Hold_Orders',
};

export const Hold_Order = 'Hold';

export const PARAMS_QUERY = {
  DIVISION_CODE: 'divisionCode',
};

export const templates = {
  'Custom Note': '',
  'Payment on Account': Texts.paymentOnAccount,
  'Payment on Account - Transfer': Texts.paymentOnAccountTransfer,
  'Due Date Change Request': Texts.dueDateChangeRequest,
  'Credit Question - Transfer': Texts.creditQuestionTransfer,
  'Close Account - Transfer': Texts.closeAccountTransfer,
  'Billing Address Update - Policy': Texts.billingAddressUpdate,
  'Contact Info Update': Texts.customerInfoUpdate,
  'Stop Email/Catalog': Texts.stopEmailCatalog,
  'Start Email/Catalog': Texts.startEmailCatalog,
  'Replacement Catalog Request': Texts.replacementCatalogRequest,
  'Status - Tracking Provided': Texts.statusTrackingProvided,
  'Status - Not Shipped Reason': Texts.statusNotShippedReason,
  'Status - Not Shipped Credit': Texts.statusNotShippedCredit,
  'Status - DP Requested': Texts.statusDpRequested,
  'Address Change Success': Texts.addressChangeSuccess,
  'Address Change Unable': Texts.addressChangeUnable,
  'Return Status - In Transit': Texts.returnStatusInTransit,
  'Return Status - Received': Texts.returnStatusRecieved,
  'Return Status - Transfer': Texts.returnStatusTransfer,
  'Return - Smart Label': Texts.returnSmartLabel,
  'Return - Charge Label': Texts.returnChargeLabel,
  'Exchange - Exchange Order': Texts.exchangeOrder,
  'Exchange - Original Order': Texts.exchangeOriginalOrder,
  'Down Payment Made': Texts.downPaymentMade,
  'Payment on Account ': Texts.paymentOnAcc, // don't remove the space at end.
  'Down Payment Inquiry': Texts.downPaymentInquiry,
  'Lost in Transit - Transfer': Texts.lostInTransitTransfer,
  'Sent Tracer': Texts.sentTracer,
  'Fraud Claim': Texts.fraudClaim,
  'Damaged - ZB/FB': Texts.damagedZBFB,
  'Damaged - Waive Fee': Texts.damagedWaiveFee,
} as any;

export const getNoteTemplate = (noteTitle: string) => {
  const temp = templates[noteTitle];
  return temp.toString();
};

export const CART_STATE_ACTIVE = 'Active';
export const CART_STATE_FROZEN = 'Frozen';
export const ISO_DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss'; //2024-05-27T19:42:32
export const DATE_FORMAT_MONTH_DATE_YYYY = 'MMMM DD, YYYY'; // May 27, 2024
